module.exports = __webpack_public_path__ + "img/custom-pin.0d8afb78.svg";